export default __webpack_public_path__ + "static/media/img_docker_monitor-colorBkg.bb690fea.png";